export default {
  title: 'ThurVPN',
  loginTitle: 'Login | ThurVPN',
};
